import { Address } from "./Address";

export class MyLocation {

    private _id: number;
    private _longitude: string;
    private _latitude: string;
    private _address: Address;
    private _fullAddress: string;

    constructor() {
        this._id = 0;
        this._longitude = "0";
        this._latitude = "0";
        this._address = new Address();
        this._fullAddress = "";
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get longitude(): string {
        return this._longitude;
    }

    set longitude(value: string) {
        this._longitude = value;
    }

    get latitude(): string {
        return this._latitude;
    }

    set latitude(value: string) {
        this._latitude = value;
    }

    get address(): Address {
        return this._address;
    }

    set address(value: Address) {
        this._address = value;
    }


    get fullAddress(): string {
        return this._fullAddress;
    }

    set fullAddress(value: string) {
        this._fullAddress = value;
    }
}